import {from, hsl} from '@viatsyshyn/ts-color';
import met_ from '@viatsyshyn/ts-simple-query';

function revolverFor(obj) {
  return (field) => {
    let values = obj;
    const path = field.split('.');
    while (values && path.length) {
      values = values[path.shift()];
    }

    return values;
  }
}

export function met(condition, obj) {
  return met_(condition, revolverFor(obj));
}

export function tpl(tpl, obj) {
  return new Function('__obj', `with(__obj) { return \`${tpl}\`; }`)(obj);
}

export function badgeColors(color) {
  const c = from(color);
  return {
    badgeColor: color,
    textColor: c.pipe(c.dark ? hsl.lighten(40) : hsl.darken(40)).toString(),
    iconColor: c.pipe(c.dark ? hsl.lighten(7) : hsl.darken(7)).toString(),
  }
}
